'use client'; // Uses next/image with onError

import React from 'react';
import Image from 'next/image';

// Replicated Metadata structure matching frontmatter
// (Could also be imported from a shared types file)
interface CaseStudyMetadata {
  slug: string;
  title: string;
  imageUrl: string;
  shortDescription: string;
}

// Card Content component
const CaseStudyCardContent: React.FC<CaseStudyMetadata> = ({
  title,
  imageUrl,
  shortDescription,
}) => (
  <>
    {/* Image Section */}
    <div className="relative w-full h-48 overflow-hidden flex-shrink-0">
      <Image
        src={imageUrl}
        alt={`Image for ${title}`}
        fill // Use fill for responsive background-like image
        style={{ objectFit: 'cover' }} // Ensure image covers the area
        className="transition-transform duration-300 group-hover:scale-110"
        sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw" // Add sizes prop for optimization
        // Optional: Add placeholder/blurDataURL for better loading experience
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.onerror = null; // Prevent infinite loop
          target.src = '/images/placeholder.jpg'; // Fallback image
          target.style.objectFit = 'contain'; // Adjust fit for placeholder
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-gray-800 via-transparent to-transparent opacity-50"></div>
    </div>

    {/* Content Section */}
    <div className="p-5 flex-grow flex flex-col justify-between">
      <div>
        <h3 className="text-xl font-bold text-[#59b9c1] mb-2 line-clamp-2">{title}</h3>
        <p className="text-gray-300 text-sm line-clamp-3">{shortDescription}</p>
      </div>
    </div>
    {/* Subtle hover effect line */}
    <div className="absolute bottom-0 left-0 h-1 w-full bg-[#59b9c1] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
  </>
);

export default CaseStudyCardContent;
